import noUiSlider from 'nouislider';
import { $, getClosest, siblings } from '../utils/Utils';
import premise from './premise';

const range = (() => {
  const config = {
    triggers: [...$('.js-range')],
    minRangeTarget: '.js-rangeMin',
    maxRangeTarget: '.js-rangeMax',
    rangeToggleTrigger: '.js-rangeToggle',
    rangerContainer: '.js-selectParent',
  };

  const handleArrowKey = ({ e, ranger, handle }) => {
    const value = ranger.noUiSlider.get();
    const index = (handle.classList.value.includes('noUi-handle-upper')) ? 1 : 0;
    let change = false;

    switch (e.key) {
      case 'ArrowLeft':
        if (index > 0) {
          // up handle
          ranger.noUiSlider.set([null, value[index] - 10]);
        } else {
          // down handle
          ranger.noUiSlider.set(value[index] - 10);
        }
        change = true;
        break;
      case 'ArrowRight':
        if (index > 0) {
          // up handle
          ranger.noUiSlider.set([null, value[index] + 10]);
        } else {
          // down handle
          ranger.noUiSlider.set(value[index] + 10);
        }
        change = true;
        break;
      default:
        break;
    }

    // check if slider is for premise
    if (ranger.classList.contains(premise.getClassname()) && change) {
      premise.update({ trigger: ranger });
    }
  };

  const handleHandles = ({ handles, ranger }) => {
    handles.forEach((handle) => {
      handle.addEventListener('keydown', e => handleArrowKey({ ranger, handle, e }));
    });
  };

  const simulateClick = (ranger) => {
    const trigger = siblings.find({ filter: config.rangeToggleTrigger, sibling: ranger })[0];
    // simulate click
    trigger.click();
  };

  const handleKeyDown = ({ e }) => {
    if (e.key === ' ') {
      // prevent browser from scrolling when pressing on space
      e.preventDefault();
      return false;
    }
  };

  const handleKeyUp = ({ ranger, parent, e }) => {
    // simulate click event when user presses specific keys
    switch (e.key) {
      case 'Enter':
      case ' ':
        simulateClick(ranger);
        if (document.activeElement !== parent) parent.focus();
        break;
      default:
        break;
    }
  };

  const handleAccessibility = (ranger) => {
    const parent = ranger.parentNode;
    const handles = ranger.querySelectorAll('.noUi-handle');
    // add tabindex to parent
    parent.setAttribute('tabindex', '0');
    // add keyboard event handling on parent (opening/closing)
    parent.addEventListener('keyup', e => handleKeyUp({ ranger, parent, e }));
    parent.addEventListener('keydown', e => handleKeyDown({ e }));
    // handle arrow left+right and change values
    handleHandles({ handles, ranger });
  };

  const toggleAppearance = (ranger) => {
    const trigger = siblings.find({ filter: config.rangeToggleTrigger, sibling: ranger })[0];

    const handleClick = (e) => {
      if (e.target !== trigger && !trigger.parentNode.contains(e.target)) {
        ranger.classList.add('-hide');
        ranger.parentNode.classList.remove('-expand');
        window.removeEventListener('click', handleClick);
      }
    };

    trigger.addEventListener('click', () => {
      if (ranger.classList.contains('-hide')) {
        // show the slider
        ranger.classList.remove('-hide');
        ranger.parentNode.classList.add('-expand');
        window.addEventListener('click', handleClick);
      } else {
        // hide the slider
        ranger.classList.add('-hide');
        ranger.parentNode.classList.remove('-expand');
        window.removeEventListener('click', handleClick);
      }
    });
  };

  const getOptions = (ranger) => {
    const values = {};

    values.current = [
      parseFloat(ranger.getAttribute('data-start-min')) || 0,
      parseFloat(ranger.getAttribute('data-start-max')) || 250,
    ];
    values.limit = [
      parseFloat(ranger.getAttribute('data-limit-min')) || 0,
      parseFloat(ranger.getAttribute('data-limit-max')) || 250,
    ];
    values.step = parseFloat(ranger.getAttribute('data-step')) || 10;

    return values;
  };

  const updateValues = (ranger) => {
    const parent = getClosest(ranger, config.rangerContainer);
    const $minRangeTarget = parent.querySelector(config.minRangeTarget);
    const $maxRangeTarget = parent.querySelector(config.maxRangeTarget);

    ranger.noUiSlider.on('update', (values, handle) => {
      (handle < 1) ? $minRangeTarget.textContent = values[handle] : $maxRangeTarget.textContent = values[handle]; // eslint-disable-line
    });
  };

  const create = (ranger) => {
    const options = getOptions(ranger);

    noUiSlider.create(ranger, {
      start: options.current,
      connect: true,
      step: options.step,
      range: {
        min: options.limit[0],
        max: options.limit[1],
      },
      format: {
        to: value => Math.round(value),
        from: value => Math.round(value),
      },
    });
  };

  const shareValue = (ranger) => {
    ranger.noUiSlider.on('end', () => premise.update({ trigger: ranger }));
  };

  const getValue = ({ ranger }) => ranger.noUiSlider.get();

  const build = () => {
    config.triggers.forEach((ranger) => {
      create(ranger);
      updateValues(ranger);
      toggleAppearance(ranger);
      handleAccessibility(ranger);

      if (ranger.classList.contains(premise.getClassname())) {
        shareValue(ranger);
      }
    });
  };

  const init = () => {
    if (config.triggers.length > 0) {
      build();
    }
  };

  return {
    init,
    getValue,
  };
})();

range.init();

export default range;

